import { backendRequest } from "@services/requestService";
import {
  API_BASE_URL,
  BASE_SERVICE_URL,
  CUSTOMER_SERVICES,
  LAWSUIT_ENDPOINTS,
} from "@constants/services/apiRoutes";
import {
  HistoricalResponse,
  LawsuitInfo,
  LawsuitListCountFetch,
  LawsuitListFetch,
} from "@customTypes/responses/lawsuit";

export const fetchLawsuitList = async ({ pageParam = -1 }) => {
  const url = `${API_BASE_URL}${BASE_SERVICE_URL.customer}${CUSTOMER_SERVICES.lawsuit}`;
  const data = await backendRequest<LawsuitListFetch>(url, "POST", {
    cursor: pageParam,
    limit: 10,
  });
  return data;
};

export const fetchLawsuitListCount = async () => {
  const url = `${API_BASE_URL}${BASE_SERVICE_URL.customer}${CUSTOMER_SERVICES}${LAWSUIT_ENDPOINTS.count}`;

  const data = await backendRequest<LawsuitListCountFetch>(url);
  return data;
};

export const fetchLawsuitById = async ({ lawsuitId }: { lawsuitId: number | string }) => {
  if (typeof lawsuitId === "string") lawsuitId = +lawsuitId;

  const url = `${API_BASE_URL}${BASE_SERVICE_URL.customer}${CUSTOMER_SERVICES.lawsuit}/${lawsuitId}`;

  const data = await backendRequest<LawsuitInfo>(url);
  return data;
};

export const fetchLawsuitHistoricals = async ({ lawsuitId, cursor }: { lawsuitId: number | string, cursor?: string }) => {
  const url = `${API_BASE_URL}${BASE_SERVICE_URL.customer}${CUSTOMER_SERVICES.lawsuit}/historical`;

  const body = {
    cursor,
    query: {
      lawsuitId,
    },
  };

  const data = await backendRequest<HistoricalResponse>(url, "POST", body);
  return data;
};
